__webpack_require__.p = "https://nice-mud-0b7ad5710.3.azurestaticapps.net/";